import moment from "moment";
import React, { Component, Fragment } from "react";
import { Container, Image } from "react-bootstrap";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";

import Button from "../../../components/UI/Button/Button";
import Search from "../../../components/UI/Input/inputSearch";
import Select from "../../../components/UI/SelectOption/SelectOption";
import * as actions from "../../../store/actions/index";
import UploadBills from "../UploadBills/UploadBills";
import Spinner from "../../../components/UI/Spinner/Spinner";
import NetworkAlert from "../../../components/UI/NetworkAlert/NetworkAlert";
import Modal from "../../../components/UI/Modal/Modal";

import billAdd from "../../../assets/images/icon-bill-add.png";
import dollar from "../../../assets/images/icon-dollar-small.svg";
import { withTranslation } from "react-i18next";
import errorStrings from "../../../errorMessages";

interface IParentProps {
  goBackHandler: () => void;
}
interface IStateFromProps {
  beneficiaryDetails: {
    primaryAccountHolder: boolean;
    patientName: string;
    patientId: number;
    isMinor: string;
    dateOfBirth: string;
  }[];
  loadingBeneficiaryDetails: boolean;
  errorMessageBeneficiaryDetails: string;
  errorBeneficiaryDetails: boolean;
  documentTypes: {
    id: string;
    type: string;
    editable: boolean;
    order: number;
  }[];
  loadingDocumentTypes: boolean;
  errorDocumentTypes: boolean;
  errorMessageDocumentTypes: string;
  claims: {
    ampsId: number;
    claimNumber: string;
    dateOfService: string;
    patientId: number;
    billedAmount: number;
    providerName: string;
    balanceBillStatus: {
      id: number;
      name: string;
      tip: string;
    };
  }[];
  loadingClaims: boolean;
  limit: number;
  page: number;
  total: number;
  balanceBillView: string;
  t: any;
  i18n: any;
}
interface IDispatchFromProps {
  onFetchBalanceBillingBeneficiaryDetails: (userId: string) => void;
  onAddNewUpload: (newUploadData: {
    beneficiarySelected: string;
    dateOfService: string;
    procedureLabel: string;
    providerName: string;
    totalChargeAmount: number;
    isMinor: boolean;
    primaryAccountHolder: boolean;
    patientId: number;
    dateOfBirth: string;
  }) => void;
  onFetchDocumentTypes: (userId: string) => void;
  onFetchAllClaims: (patientId: number, limit: number, page: number) => void;
  onSetBalanceBillViewState: (balanceBillView) => void;
  // onRemoveExplanationOfBenefitsFiles: (fileArray: File[]) => void;
  // onRemoveProviderBillsFiles: (fileArray: File[]) => void;
  // onRemovePatientsResponsibilityFiles: (fileArray: File[]) => void;
  // onResetDisputeAuthorizationFile: () => void;
  // onResetSubmitBills: () => void;
  // onResetSubmitBalanceBillingClaim: () => void;
  // onResetSubmitContactInformation: () => void;
  // onRemoveCollectionNoticeBills: (fileArray: File[]) => void;
  // onRemoveSubsequentProviderBills: (fileArray: File[]) => void;
}
type Props = IParentProps & IStateFromProps & IDispatchFromProps;

class Claims extends Component<Props> {
  state = {
    claimId: 0,
    beneficiarySelected: "Select",
    // dateOfService: moment(new Date()).format("MM/DD/YYYY"),
    procedureLabel: "",
    providerName: "",
    totalChargeAmount: "",
    errorUserId: false,
    formValid: false,
    providerBillingStatement: false,
    isMinor: false,
    primaryAccountHolder: false,
    patientId: 0,
    patientName: "",
    dateOfBirth: "",
    inputSearch: "",
    error: this.props.errorBeneficiaryDetails,
    errorDocumentTypes: this.props.errorDocumentTypes,
    searchedClaims: [] as {
      ampsId: number;
      claimNumber: string;
      dateOfService: string;
      patientId: number;
      billedAmount: number;
      providerName: string;
      balanceBillStatus: {
        id: number;
        name: string;
        tip: string;
      };
    }[],
  };
  componentDidMount() {
    console.log("componentDidMount in claims");
    // this.props.onSetBalanceBillViewState("");
    const userId = localStorage.getItem("userId");
    if (userId !== null) {
      this.props.onFetchBalanceBillingBeneficiaryDetails(userId);
      this.props.onFetchDocumentTypes(userId);
    } else {
      this.setState({ errorUserId: true });
    }
  }
  componentDidUpdate(prevProps, prevState) {
    console.log("componentDidUpdate in claims");
    if (
      prevProps.errorBeneficiaryDetails !== this.props.errorBeneficiaryDetails
    ) {
      this.setState({ error: this.props.errorBeneficiaryDetails });
    }
    if (prevProps.errorDocumentTypes !== this.props.errorDocumentTypes) {
      this.setState({ errorDocumentTypes: this.props.errorDocumentTypes });
    }
    if (
      JSON.stringify(prevProps.beneficiaryDetails) !==
        JSON.stringify(this.props.beneficiaryDetails) &&
      this.props.beneficiaryDetails[0].patientName !== ""
    ) {
      this.props.onFetchAllClaims(
        this.props.beneficiaryDetails[0].patientId,
        this.props.limit,
        this.props.page
      );
      this.setState({
        beneficiarySelected: this.props.beneficiaryDetails[0].patientName,
      });
      this.setState({
        patientName: this.props.beneficiaryDetails[0].patientName,
      });
      this.setState({
        isMinor: this.props.beneficiaryDetails[0].isMinor,
      });
      this.setState({
        dateOfBirth: this.props.beneficiaryDetails[0].dateOfBirth,
      });
      this.setState({
        primaryAccountHolder: this.props.beneficiaryDetails[0]
          .primaryAccountHolder,
      });
      this.setState({
        patientId: this.props.beneficiaryDetails[0].patientId,
      });
    }
    if (prevProps.errorDocumentTypes !== this.props.errorDocumentTypes) {
      this.setState({ errorDocumentTypes: this.props.errorDocumentTypes });
    }


    if (prevProps.balanceBillView !== this.props.balanceBillView) {
      console.log("inside if of getStarted");
      if (this.props.balanceBillView === "providerBillingStatement") {
        this.setState({ providerBillingStatement: true });
      } else if (
        this.props.balanceBillView === "notProviderBillingStatement" ||
        this.props.balanceBillView === ""
      ) {
        this.setState({ providerBillingStatement: false });
      }
    }
  }
  handleChange = (e) => {
    if (e.target.name === "beneficiarySelected") {
      console.log(
        "beneficiarySelected",
        this.props.beneficiaryDetails[e.target.selectedIndex]
          .primaryAccountHolder
      );
      this.setState({
        beneficiarySelected: this.props.beneficiaryDetails[
          e.target.selectedIndex
        ].patientName,
        errorBeneficiarySelected: "",
      });
      this.setState({
        patientName: this.props.beneficiaryDetails[e.target.selectedIndex]
          .patientName,
      });
      this.setState({
        isMinor: this.props.beneficiaryDetails[e.target.selectedIndex].isMinor,
      });
      this.setState({
        dateOfBirth: this.props.beneficiaryDetails[e.target.selectedIndex]
          .dateOfBirth,
      });
      this.setState({
        primaryAccountHolder: this.props.beneficiaryDetails[
          e.target.selectedIndex
        ].primaryAccountHolder,
      });
      this.setState({
        patientId: this.props.beneficiaryDetails[e.target.selectedIndex]
          .patientId,
      });
      this.setState({ inputSearch: "" });
      this.props.onFetchAllClaims(
        this.props.beneficiaryDetails[e.target.selectedIndex].patientId,
        20,
        0
      );
    } else if (e.target.name === "inputSearch") {
      console.log("this.state.inputSearch", this.state.inputSearch);
      console.log("e.target.value", e.target.value);

      let searchedClaims: any;
      if (e.target.value !== "") {
        searchedClaims = this.props.claims.filter((ele) => {
          console.log("ele", ele);
          return (
            ele.providerName
              .toLowerCase()
              .match(e.target.value.toLowerCase()) ||
            ele.claimNumber.toLowerCase().match(e.target.value.toLowerCase()) ||
            ele.billedAmount
              .toString()
              .toLowerCase()
              .match(e.target.value.toLowerCase()) ||
            ele.dateOfService
              .toString()
              .toLowerCase()
              .match(e.target.value.toLowerCase()) ||
            ele.ampsId
              .toString()
              .toLowerCase()
              .match(e.target.value.toLowerCase()) ||
            this.state.patientId
              .toString()
              .toLowerCase()
              .match(e.target.value.toLowerCase()) ||
            this.state.patientName
              .toString()
              .toLowerCase()
              .match(e.target.value.toLowerCase())
          );
        });
      } else {
        searchedClaims = [];
      }
      this.setState({
        [e.target.name]: e.target.value,
        searchedClaims: [...searchedClaims],
      });
    }
  };
  beneficiaryHandleChange = (e) => {
    this.setState({
      beneficiarySelected: e.value,
      errorBeneficiarySelected: "",
    });
    this.setState({
      patientName: this.props.beneficiaryDetails[e.target.selectedIndex - 1]
        .patientName,
    });
    this.setState({
      isMinor: this.props.beneficiaryDetails[e.target.selectedIndex - 1]
        .isMinor,
    });
    this.setState({
      dateOfBirth: this.props.beneficiaryDetails[e.target.selectedIndex - 1]
        .dateOfBirth,
    });
    this.setState({
      primaryAccountHolder: this.props.beneficiaryDetails[
        e.target.selectedIndex - 1
      ].primaryAccountHolder,
    });
    this.setState({
      patientId: this.props.beneficiaryDetails[e.target.selectedIndex - 1]
        .patientId,
    });
  };
  handleUploadBills = (index) => {
    const {
      beneficiarySelected,
      isMinor,
      primaryAccountHolder,
      patientId,
      dateOfBirth,
    } = this.state;
    const newUploadData = {
      // claimId: this.props.claims[index].id,
      beneficiarySelected,
      dateOfService: moment.utc(this.props.claims[index].dateOfService).format(
        "MM/DD/YYYY"
      ),
      procedureLabel: "",
      providerName: this.props.claims[index].providerName,
      totalChargeAmount: this.props.claims[index].billedAmount,
      isMinor,
      primaryAccountHolder,
      patientId,
      dateOfBirth,
      ampsId: this.props.claims[index].ampsId,
    };
    // console.log("newuploaddata", newUploadData);
    this.props.onAddNewUpload(newUploadData);
    // this.setState({ providerBillingStatement: true });
    this.props.onSetBalanceBillViewState("providerBillingStatement");
  };

  providerBillingStatementBackHandler = () => {
    // this.setState({ providerBillingStatement: false });
    this.props.onSetBalanceBillViewState("notProviderBillingStatement");
  };
  getMoreResults = () => {
    this.props.onFetchAllClaims(
      this.state.patientId,
      this.props.limit,
      this.props.page
    );
  };
  errorAlertClosedHandler = () => {
    this.setState({ error: false });
  };
  render() {
    const { t, i18n } = this.props;
    // console.log("this.props.claims", this.props.claims);
    // console.log("this.state.searchedClaims", this.state.searchedClaims);
    const btnStyle = {};
    const modalChildStyle = {};
    const { goBackHandler, beneficiaryDetails } = { ...this.props };
    const elementLabelStyle = {
      fontSize: "13px",
      fontWeight: "600",
      color: "#117093",
      marginBottom: "3px",
    };

    const elementInputStyle = {
      margin: "0",
      fontSize: "12px",
      padding: "4px 10px",
      minHeight: "28px",
      borderRadius: "3px",
      minWidth: "100px",
    };
    let spinner: any;
    if (
      this.props.loadingBeneficiaryDetails ||
      this.props.loadingDocumentTypes ||
      this.props.loadingClaims
    ) {
      spinner = <Spinner />;
    }

    /*error message display*/
    let errorMessagePopup: any;
    if (this.state.error) {
      // console.log("this.state.error", this.state.error);
      errorMessagePopup = (
        <Modal
          show={this.state.error}
          childComp={
            <NetworkAlert
              networkErrorText={false}
              modalClosed={this.errorAlertClosedHandler}
              error={
                errorStrings(this.props.errorMessageBeneficiaryDetails)
                  ? t(errorStrings(this.props.errorMessageBeneficiaryDetails))
                  : this.props.errorMessageBeneficiaryDetails
              }
            />
          }
          style={modalChildStyle}
        />
      );
    }
    let benificiaries = ["Select"];
    if (beneficiaryDetails) {
      benificiaries = beneficiaryDetails.map((res) => res.patientName);
    }
    let claims: any;
    if (this.state.searchedClaims.length > 0) {
      console.log("this.state.searchedClaims", this.state.searchedClaims);
      claims = this.state.searchedClaims.map((claim, index) => (
        <div className="list-col-2" key={index}>
          <div className="list-col2-inner">
            <h6>{claim.providerName}</h6>
            <h5>{this.state.patientName}</h5>
            <ul>
              <li>
                <strong>
                  {t("balanceBills.patientId")}{" "}
                  <span>{this.state.patientId}</span>
                </strong>
              </li>
              <li>
                {t("balanceBills.dateOfService")}{" "}
                <span>{moment.utc(claim.dateOfService).format("MM/DD/YYYY")}</span>
              </li>
              <li>
                {t("balanceBills.billAmount")}
                <span>{claim.billedAmount}</span>
              </li>
              <li>
                {t("balanceBills.ampsId")} <span>{claim.ampsId}</span>
              </li>
              <li>
                {t("balanceBills.claims#")} <span>{claim.claimNumber}</span>
              </li>
            </ul>
            <div className="list-col-btn">
              <span className="pointer">
                {this.props.errorDocumentTypes ? (
                  <Image src={billAdd} alt="billAdd" />
                ) : (
                  <Image
                    src={billAdd}
                    alt="billAdd"
                    onClick={() => this.handleUploadBills(index)}
                  />
                )}
              </span>
            </div>
          </div>
        </div>
      ));
    } else if (this.state.inputSearch === "" && this.props.claims.length > 0) {
      console.log("this.props.claims", this.props.claims);
      claims = this.props.claims.map((claim, index) => (
        <div className="list-col-2" key={index}>
          <div className="list-col2-inner">
            <h6>{claim.providerName}</h6>
            <h5>{this.state.patientName}</h5>
            <ul>
              <li>
                <strong>
                  {t("balanceBills.patientId")}{" "}
                  <span>{this.state.patientId}</span>
                </strong>
              </li>
              <li>
                {t("balanceBills.dateOfService")}{" "}
                <span>{moment.utc(claim.dateOfService).format("MM/DD/YYYY")}</span>
              </li>
              <li>
                {t("balanceBills.billAmount")}
                <span>{claim.billedAmount}</span>
              </li>
              <li>
                {t("balanceBills.ampsId")} <span>{claim.ampsId}</span>
              </li>
              <li className="full-area">
                {t("balanceBills.claims#")} <span>{claim.claimNumber}</span>
              </li>
            </ul>
            <div className="list-col-btn">
              <span className="pointer">
                {this.props.errorDocumentTypes ? (
                  <Image src={billAdd} alt="billAdd" />
                ) : (
                  <span>
                    <a data-for="toolTip" data-tip={t("balanceBills.tooltip")}>
                      <Image
                        src={billAdd}
                        alt="billAdd"
                        onClick={() => this.handleUploadBills(index)}
                      />{" "}
                    </a>
                    <ReactTooltip
                      id="toolTip"
                      place="left"
                      effect="float"
                      backgroundColor="#aaa"
                    />
                  </span>
                )}
              </span>
            </div>
          </div>
        </div>
      ));
    } else if (
      !this.props.loadingClaims &&
      !this.props.loadingBeneficiaryDetails &&
      !this.props.loadingDocumentTypes
    ) {
      claims = (
        <div className="no-data">
          <div className="no-data-msg">{t("balanceBills.noClaims")}</div>
        </div>
      );
    }

    let uploadBills: any;
    if (this.state.providerBillingStatement) {
      uploadBills = (
        <UploadBills
          i18n={i18n}
          t={t}
          goBackHandler={this.providerBillingStatementBackHandler}
        />
      );
    } else {
      uploadBills = (
        <Container fluid>
          {spinner}
          {errorMessagePopup}
          <div className="inner-banner">
            <div className="inner-banner-title">
              <h3>{t("balanceBills.balanceBilling")}</h3>
              <Image src={dollar} alt="stock-image" data-test="stockIMG" />
            </div>
          </div>
          <div className="title-left">
            <h6 className="bill-heading">{t("balanceBills.claims")}</h6>
          </div>
          <div className="bills-section">
            <div className="bill-serach">
              <div className="bill-sec-fixed">
                <div className="row">
                  <div className="col-md-6">
                    <Select
                      label={t("balanceBills.selectPatient")}
                      supportLabel=""
                      options={benificiaries}
                      elementLabelStyle={elementLabelStyle}
                      elementInputStyle={elementInputStyle}
                      value={this.state.beneficiarySelected}
                      onChange={(e) => this.handleChange(e)}
                      name="beneficiarySelected"
                      errorText={""}
                    />
                  </div>
                  <div className="col-md-6 hide-label-m">
                    <Search
                      label=""
                      supportLabel=""
                      placeholder={t("placeHolder.search")}
                      elementLabelStyle={elementLabelStyle}
                      elementInputStyle={elementInputStyle}
                      name="inputSearch"
                      errorText={""}
                      value={this.state.inputSearch}
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                </div>
              </div>
            </div>
            {claims}
          </div>
          {/* bills-section end */}
          <div className="equal-buttons">
            <Button
              label={t("balanceBills.backBtn")}
              clicked={goBackHandler}
              style={btnStyle}
              displayImg={false}
              image=""
              disabled={false}
            />
            <Button
              label={t("balanceBills.showMoreBtn")}
              clicked={this.getMoreResults}
              style={btnStyle}
              displayImg={false}
              image=""
              disabled={
                this.state.inputSearch.length > 0 ||
                (this.state.inputSearch.length > 0 &&
                  this.state.searchedClaims.length <= 0) ||
                this.props.claims.length <= 0 ||
                this.props.claims.length >= this.props.total
                  ? true
                  : false
              }
            />
          </div>
        </Container>
      );
    }
    return <Fragment>{uploadBills}</Fragment>;
  }
}
const mapStateToProps = (state: any) => ({
  beneficiaryDetails: state.bbNewUpload.beneficiaryDetails,
  loadingBeneficiaryDetails: state.bbNewUpload.loading,
  errorMessageBeneficiaryDetails: state.bbNewUpload.errorMessage,
  errorBeneficiaryDetails: state.bbNewUpload.error,
  loadingDocumentTypes: state.fetchDocumentTypes.loading,
  errorDocumentTypes: state.fetchDocumentTypes.error,
  documentTypes: state.fetchDocumentTypes.documentTypes,
  errorMessageDocumentTypes: state.fetchDocumentTypes.errorMessage,
  claims: state.fetchAllClaims.claims,
  loadingClaims: state.fetchAllClaims.loading,
  limit: state.fetchAllClaims.limit,
  page: state.fetchAllClaims.page,
  total: state.fetchAllClaims.total,
  balanceBillView: state.setBalanceBillViewState.balanceBillView,
});
const mapDispatchToProps = (dispatch): IDispatchFromProps => ({
  onFetchDocumentTypes: (userId) =>
    dispatch(actions.fetchDocumentTypes(userId)),
  onFetchBalanceBillingBeneficiaryDetails: (userId) =>
    dispatch(actions.fetchBeneficiaryDetails(userId)),
  onAddNewUpload: (newUploaddata) =>
    dispatch(actions.addNewUpload(newUploaddata)),
  onFetchAllClaims: (patientId, limit, page) =>
    dispatch(actions.fetchAllClaims(patientId, limit, page)),
  onSetBalanceBillViewState: (balanceBillView) =>
    dispatch(actions.setBalanceBillViewState(balanceBillView)),
  // onRemoveExplanationOfBenefitsFiles: (explanationOfBenefitsBills) =>
  // dispatch(actions.explanationOfBenefitsBills(explanationOfBenefitsBills)),
  // onRemoveProviderBillsFiles: (providerBills) =>
  //   dispatch(actions.providerBills(providerBills)),
  // onRemovePatientsResponsibilityFiles: (patientsResponsibilityBills) =>
  //   dispatch(actions.patientsResponsibilityBills(patientsResponsibilityBills)),
  // onResetDisputeAuthorizationFile: () =>
  //   dispatch(actions.resetDisputeAuthorizationFile()),
  // onRemoveCollectionNoticeBills: (collectionNoticeBills) =>
  //   dispatch(actions.collectionNoticeBills(collectionNoticeBills)),
  // onRemoveSubsequentProviderBills: (subsequentProviderBills) =>
  //   dispatch(actions.subsequentProviderBills(subsequentProviderBills)),
  // onResetSubmitBills: () => dispatch(actions.resetSubmitBills()),
  // onResetSubmitBalanceBillingClaim: () =>
  //   dispatch(actions.resetSubmitBalanceBillingClaim()),
  // onResetSubmitContactInformation: () =>
  //   dispatch(actions.resetSubmitContactInformation()),
});
// export default connect(mapStateToProps, mapDispatchToProps)(Claims);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Claims));
